import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-index',
  templateUrl: './message-index.component.html',
  styleUrls: ['./message-index.component.scss']
})
export class MessageIndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
